// client/src/coms/components/ComsCornerAd.js
import React, { useMemo } from 'react';
import AdSlot from '../../components/AdSlot';

export default function ComsCornerAd({
  serverId,
  serverName,
  channelId,
  tab,
  enabled = true,
}) {
  const adId = 'Coms_corner_banner';

  const targeting = useMemo(() => {
    return {
      placement: 'coms_corner',
      server_id: serverId ? String(serverId) : '0',
      server: serverName ? String(serverName) : '',
      channel: channelId ? String(channelId) : '',
      tab: tab ? String(tab) : '',
    };
  }, [serverId, serverName, channelId, tab]);

  if (!enabled) return null;

  return (
    <div className="coms-corner-ad">
      <AdSlot
        id={adId}
        sizes={[[320, 50]]}
        targeting={targeting}
        refreshLimit={20}
        refreshTime={30}
        refreshVisibleOnly={true}
      />
    </div>
  );
}